export default __webpack_public_path__ + "static/media/tag-icon-knowledge.c8194578.svg";